import React from 'react';
import { ButtonIcon, SecondaryButton } from '@hz-design-system/web-ui';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import VIEW_OPTIONS from '@/constants/viewOptions';
import ViewControlGroup from '@/client/components/ViewControls/atoms/ViewControlGroup';

type TViewOptionsControl = {
  kind: string;
  onChange: (kind: string) => void;
};

const ViewOptionsControl = ({ kind, onChange }: TViewOptionsControl) => {
  const { t } = useI18nContext();

  return (
    <ViewControlGroup type="view-options" role="tablist">
      <SecondaryButton
        role="tab"
        className={`results-button ${kind === VIEW_OPTIONS.LIST_VIEW ? 'isActive' : ''}`}
        onClick={() => onChange(VIEW_OPTIONS.LIST_VIEW)}
        aria-label={t('viewControls.list')}
        aria-selected={kind === VIEW_OPTIONS.LIST_VIEW}
      >
        <ButtonIcon name="results-list" isStartIcon />
        <Trans className="view-option-label" i18nKey="viewControls.list" tagName="span" />
      </SecondaryButton>
      <SecondaryButton
        role="tab"
        className={`results-button ${kind === VIEW_OPTIONS.GALLERY_VIEW ? 'isActive' : ''}`}
        onClick={() => onChange(VIEW_OPTIONS.GALLERY_VIEW)}
        aria-label={t('viewControls.photos')}
        aria-selected={kind === VIEW_OPTIONS.GALLERY_VIEW}
      >
        <ButtonIcon name="view-gallery" isStartIcon />
        <Trans className="view-option-label" i18nKey="viewControls.photos" tagName="span" />
      </SecondaryButton>
    </ViewControlGroup>
  );
};

export default ViewOptionsControl;
